export default {
   'baseUrl': process.env.VUE_APP_BASE_URL,
   'uploadAddr': process.env.VUE_APP_UPLOAD_ADDR,
   'webUrl': process.env.VUE_APP_WEB_URL,
   'title': process.env.VUE_APP_TITLE,
   'env': process.env.VUE_APP_ENV,
   'NODE_ENV':process.env.NODE_ENV
}

